import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { CommonModule } from "@angular/common";
import { DashboardRoutingModule } from "./dashboard-routing.module";
import { DashboardComponent } from "./dashboard.component";
import { NgChartsModule } from "ng2-charts";
import { Ng2GoogleChartsModule } from "ng2-google-charts";
import { NgxChartsModule } from "@swimlane/ngx-charts";
import { ChartistModule } from "ng-chartist";
import { SharedModule } from "../../shared/shared.module";
import { NgbCollapseModule } from "@ng-bootstrap/ng-bootstrap";
import { CardFirmaComponent } from "./card-firma/card-firma.component";

@NgModule({
  declarations: [DashboardComponent, CardFirmaComponent],
  imports: [
    CommonModule,
    DashboardRoutingModule,
    SharedModule,
    NgChartsModule,
    Ng2GoogleChartsModule,
    NgxChartsModule,
    ChartistModule,
    NgbCollapseModule,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class DashboardModule {}
